'use strict';

import * as React from 'react';
import { renderToStaticMarkup } from "react-dom/server";
import { getActivityItem } from "../react_components/aside_panel/boardDetails/activity/TabActivity/helpers/aсtivityHelper";
import { ActivityPriority } from '../react_components/aside_panel/cardDetails/TabActivity/components/ActivityPriority/ActivityPriority';

App.Views.CardAddPriorityNotification = App.Views.BaseNotification.extend({

    getActions: function() {
        const item = getActivityItem(this.notificationModel);
        const { oldValue, newValue } = this.notificationModel;
        return {
            bodyRaw: renderToStaticMarkup(<>
                {oldValue && <ActivityPriority priority={oldValue} removed={true} />}
                {newValue && <ActivityPriority priority={newValue} />}
            </>),
            action: item.label,
        };
    },

    onClick: function(e, notification) {
        var dashboardId = this.notificationModel.dashboardId;
        var cardId = this.notificationModel.card.id;
        App.controller.cleverOpenCard(dashboardId, cardId);
        this.closeNotification(notification);
        e.stopPropagation();
    }
});
